<template>
  <vue-scroll>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="DETECTION INFORMATION" name="detection" v-if="!iocDetails.lateralmove">
        <span v-if="iocDetails.rule" class="tactic-block">
          <div>
            <span class="subtitle2">Summary</span><span class="value"> {{ iocDetails.iocSummary | removeInfluencer }} </span>
          </div>
          <div v-if="!$_.isEmpty(iocDetails.rule.tactic)">
            <span class="subtitle2">Tactic</span>
            <span class="value">
              <a :href="iocDetails.rule.externalTacticUrl" target="_blank" rel="noreferrer"
                >{{ iocDetails.rule.tactic }}:
                {{ iocDetails.rule.mitreAttackTactic ? iocDetails.rule.mitreAttackTactic.name : '' }}</a
              >
            </span>
          </div>
          <div v-if="!$_.isEmpty(iocDetails.rule.technique)">
            <span class="subtitle2">Technique</span>
            <span class="value">
              <a :href="iocDetails.rule.externalTechniqueUrl" target="_blank" rel="noreferrer"
                >{{ iocDetails.rule.technique }}:
                {{ iocDetails.rule.mitreAttackTechnique ? iocDetails.rule.mitreAttackTechnique.name : '' }}</a
              >
            </span>
          </div>
        </span>
        <div v-if="!iocDetails.rule && !$_.isEmpty(iocDetails.iocTactic)">
          <span class="subtitle2">Tactic</span> <span class="value">{{ iocDetails.iocTactic }}</span>
        </div>
      </el-collapse-item>
      <el-collapse-item title="HOST" name="host" v-if="!iocDetails.lateralmove">
        <div v-if="!$_.isEmpty(iocDetails.agentDetails.customHostname || iocDetails.agentIdLabel)">
          <span class="subtitle2">Name</span>
          <router-link class="value" :to="{ name: 'host-insights', params: { agentId: iocDetails.agentId } }">
            {{ iocDetails.agentDetails.customHostname || iocDetails.agentIdLabel }}
          </router-link>
        </div>
        <div v-if="!$_.isEmpty(iocDetails.agentDetails.system)">
          <span class="subtitle2">OS/Version</span>
          <span class="value">
            <span class="capitalize">{{
              iocDetails.agentDetails.system ? `${iocDetails.agentDetails.system.os}` : ''
            }}</span>
            {{ iocDetails.agentDetails.system ? `(${iocDetails.agentDetails.system.platform})` : '' }}
          </span>
        </div>
        <div v-if="!$_.isEmpty(iocDetails.agentDetails.localIPs)">
          <span class="subtitle2">Local IP Address</span>
          <span class="value">
            <span v-for="(ip, idx) in iocDetails.agentDetails.localIPs" :key="idx"> {{ ip }} <br /> </span>
          </span>
        </div>
      </el-collapse-item>
      <el-collapse-item title="CONTAINER" name="container" v-if="!$_.isEmpty(iocDetails.containerDetails)">
        <div
          v-if="
            !$_.isEmpty(iocDetails.containerDetails.trailblazerContainerMetadata) &&
              !$_.isEmpty(iocDetails.containerDetails.trailblazerContainerMetadata.containerNames)
          "
        >
          <span class="subtitle2">Name</span>
          <span class="value">{{
            getContainerName(iocDetails.containerDetails.trailblazerContainerMetadata.containerNames[0])
          }}</span>
        </div>
        <div
          v-else-if="
            !$_.isEmpty(iocDetails.containerDetails.containerMetadata) &&
              !$_.isEmpty(iocDetails.containerDetails.containerMetadata.containerNames)
          "
        >
          <span class="subtitle2">Name</span>
          <span class="value">{{
            getContainerName(iocDetails.containerDetails.containerMetadata.containerNames[0])
          }}</span>
        </div>
        <div v-if="!$_.isEmpty(iocDetails.containerDetails.containerId)">
          <span class="subtitle2">ID</span>
          <span class="value">{{ iocDetails.containerDetails.containerId }}</span>
        </div>
        <div v-if="!$_.isEmpty(iocDetails.containerImageId)">
          <span class="subtitle2">Image ID</span>
          <span class="value">{{ iocDetails.containerImageId }}</span>
        </div>
      </el-collapse-item>
      <el-tabs v-model="activeTab">
        <el-tab-pane
          :label="`Event ${idx + 1}`"
          v-for="(details, idx) in iocDetails.iocEventsList"
          :key="idx"
          :name="`${idx}`"
        >
          <ioc-event-details-content
            :ioc-details-content="details"
            :operating-system="iocDetails.agentDetails.system ? `${iocDetails.agentDetails.system.os}` : 'linux'"
          ></ioc-event-details-content>
        </el-tab-pane>
      </el-tabs>
    </el-collapse>
  </vue-scroll>
</template>

<script>
import { getContainerNameLabel } from '@/utilities/agent.helper'
import IocEventDetailsContent from '@/components/feed/ioc-details/IocEventDetailsContent.vue'

export default {
  name: 'IocMultiEventDetails',
  props: {
    iocDetails: {
      default: () => {
        return {}
      },
      type: [Array, Object]
    }
  },
  data () {
    return {
      activeNames: ['detection', 'host', 'container'],
      activeTab: '0' // event index, default to 0 to open first tab,
    }
  },
  filters: {
    removeInfluencer: function (value) {
      if (!value) return ''
      if (!value.includes('[')) return value
      return value.split('[')[0]
    }
  },
  methods: {
    getContainerName (name) {
      return getContainerNameLabel(name)
    }
  },
  components: {
    IocEventDetailsContent
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.el-collapse {
  overflow: scroll;
  border-bottom: none;
}

>>> .el-tabs__nav-wrap {
  margin: 0px 10px;
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.el-collapse-item >>> .el-collapse-item__content,
.tactic-block {
  > div {
    display: flex;
    flex-wrap: nowrap;
    padding: 10px;

    > .subtitle2,
    .value {
      flex-grow: 1;
      align-self: auto;
      width: 50%;
    }
  }

  .el-divider {
    width: 90%;
    margin: 0px 10px;
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/feed/ioc-details/IocMultiEventDetails.vue